import {
  ContentBlock,
  ContentState,
  convertFromHTML,
  convertToRaw,
  genKey,
  Modifier,
  SelectionState,
} from 'draft-js'
import { OrderedMap } from 'immutable'
import type { TextElement } from 'types/content-editor'

const titleMarkup = (title: string) => `<h1>${title}</h1>`

export const regularMarkup = (): string => `
<p>
Enter your content here. You can add links and set formatting via the menu bar above. For settings that apply to the whole block, edit these in the "Section Settings" area on the right hand side of the app.
</p>
<p>
Need more help? Check out our <a href="https://support.disco.ac/home" target="_blank">Help Site</a>.
</p>
`

const imageMarkup = (src: string) => `<img src="${src}" /> `

// there should be less ugly way to insert image entity and content block
// but this works with some low level draft js API, so it was at least
// educational
const getContentWithImage = (content: ContentState, imgSrc: string) => {
  const contentWithEntity = content.createEntity('image', 'IMMUTABLE', {
    src: imgSrc,
  })
  const entityKey = contentWithEntity.getLastCreatedEntityKey()
  const blockMap = contentWithEntity.getBlockMap()
  const newBlockKey = genKey()
  const newBlocks: [string, ContentBlock][] = [
    [
      newBlockKey,
      new ContentBlock({
        key: newBlockKey,
        type: 'atomic',
        text: '',
      }),
    ],
  ]
  const newBlockMap = OrderedMap(newBlocks)
    .concat(blockMap || [])
    .toOrderedMap()
  const contentWithImage = contentWithEntity.merge({
    blockMap: newBlockMap,
  })
  const selectionState = SelectionState.createEmpty(newBlockKey)
  return Modifier.insertText(
    contentWithImage,
    selectionState,
    ' ',
    null,
    entityKey,
  )
}

export const imageColumnTemplate = (imgSrc: string): TextElement => {
  const content = new ContentState()
  const contentWithImage = getContentWithImage(content, imgSrc)
  return {
    type: 'text',
    content: convertToRaw(contentWithImage),
    htmlContent: imageMarkup(imgSrc),
  }
}
export const columnTemplate = (title: string, imgSrc?: string): TextElement => {
  const htmlContent = titleMarkup(title) + regularMarkup()
  const blocks = convertFromHTML(htmlContent)
  const content = ContentState.createFromBlockArray(
    blocks.contentBlocks,
    blocks.entityMap,
  )

  if (imgSrc) {
    const contentWithImage = getContentWithImage(content, imgSrc)
    return {
      type: 'text',
      content: convertToRaw(contentWithImage),
      htmlContent: imageMarkup(imgSrc) + htmlContent,
    }
  }

  return {
    type: 'text',
    content: convertToRaw(content),
    htmlContent,
  }
}
